<template>
    <v-container fluid>
      <v-card style="text-align: center; margin-bottom: 1rem; padding: 1rem;">{{ numberOfBookedStalls }} stalls booked for {{ dateFormatted }}</v-card>
      <v-card :dark="filter.isDefaults ? true : false">
        <v-card-title>Market Details</v-card-title>
        <v-card-text>
          <!-- Kirribilli doesn't use default stallholders -->
          <!-- <v-row >
            <v-col>
              <v-switch v-model="filter.isDefaults" label="Show Default Stallholders" class="pa-3"></v-switch>
            </v-col>
          </v-row> -->
          <v-row>
            <v-col v-if="!filter.isDefaults" class="d-flex align-center">
              <v-menu
                v-model="datemenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
                :nudge-right="50"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="dateFormatted"
                    label="Market Date"
                    prepend-icon="mdi-calendar-range"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="date"
                  :allowed-dates="allowedDates"
                  @input="datemenu = false"
                  @change="loadBookingsDate"
                  @update:picker-date="pickerUpdate($event)"
                >
                </v-date-picker>
              </v-menu>

              <!-- TODO functiontioanlity needs to be updated for the prev/next buttons for them to work -->
              <!-- <v-btn class="ml-3 mr-3" depressed
                @click.stop="incrementDate(-1)">
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>

              <v-btn class="mr-3" depressed
                @click="incrementDate(1)">
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn> -->

              <v-btn depressed class="ml-4"
                @click="getBookings()">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>

              <v-spacer></v-spacer>

            </v-col>
            <v-col class="d-flex align-center"  v-if="!filter.isDefaults">
              <v-spacer></v-spacer>

              <v-select
              v-model="filterBy"
              :items="filterOptions"
              label="Display"
              item-text="text"
              item-value="value"
              ></v-select>

              <!-- <v-switch v-if="!filter.isDeleted" v-model="filter.isEmpty" label="Show Empty Stalls" class="pa-3"></v-switch>
              <v-switch v-model="filter.isDeleted" label="Show Deleted Bookings" class="pa-3"></v-switch>
              <v-switch v-model="filter.isExpired" label="Show Expired Bookings" class="pa-3"></v-switch> -->
              <v-switch v-model="marketOptions.ignore_rules"
              label="Disable all rules this week" class="pa-3"
              :loading="optionsLoading"
              @change="updateMarketOptions('ignore_rules', $event)">
              </v-switch>
            </v-col>
          </v-row>
          <v-row class="mb-6">
            <v-col>
              <v-text-field align-self="center"
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="!filter.isDefaults" class="pb-4">
              <v-col
                class="pr-6 py-3"
                v-if="!isLoading"
              >
                <span class="mr-2">Remaining:</span>
                <v-chip
                  class="ma-2"
                  :color="data.qty > 1 ? 'green' : data.qty < 0 ? 'red' : ''"
                  :text-color="data.qty === 0 ? 'black' : 'white'"
                  v-for="(data, code) in marketOptions.stock"
                  :key="code"
                >
                  <v-avatar
                    left
                    :class="[{ 'green darken-3' : data.qty > 1}, { 'red darken-4' : data.qty < 0}, { 'grey darken-1' : data.qty === 0}]"
                  >
                  <span class="white--text font-weight-medium">
                    {{data.qty}}
                  </span>
                  </v-avatar>
                  {{data.name}}
                </v-chip>
              </v-col>
              <v-col align="right" class="px-4">
                <v-btn
                  class="ma-2 mr-8"
                  color="primary"
                  @click="openBookStallDialog()"
                >
                  Book A Stall
                </v-btn>
                <!-- <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-btn @click="getExcel(`/wisdom-markets/v1/payment-report`)" color="success" fab small dark v-on="on" class="mr-4" :loading="downloadsLoading.includes(`/wisdom-markets/v1/payment-report`)">
                      <v-icon>mdi-currency-usd</v-icon>
                    </v-btn>
                  </template>
                  <span>Download Payment Report</span>
                </v-tooltip> -->
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-btn @click="getExcel(`/wisdom-markets/v1/market-overview/${date}`)" color="success" fab small dark v-on="on" :loading="downloadsLoading.includes(`/wisdom-markets/v1/market-overview/${date}`)">
                      <v-icon>mdi-file-download</v-icon>
                    </v-btn>
                  </template>
                  <span>Download Market Overview xlsx</span>
                </v-tooltip>
              </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-data-table
          :headers="tableHeaders"
          :items="tableData"
          :search="search"
          :loading="isLoading"
          hide-default-footer
          disable-pagination
          :custom-sort="customBookingsSort"
          :dark="filter.isDefaults ? true : false"
        >
          <template v-slot:item.name="{ item }">
            {{ item.name }}
            <v-btn text icon x-small
              color="grey"
             @click="openStallDialog(item.stall_id)"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
             <v-btn v-if="item.stall_admin_note" text icon x-small
              color="grey"
             @click="openStallDialog(item.stall_id)"
            >
              <v-icon>mdi-note</v-icon>
            </v-btn>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-menu bottom left v-if="!isLoading">
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-on="on"
                >
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
  
              <v-list v-if="isBooked(item)">
                <v-list-item @click="openEditBookingDialog(item.booking_id)">
                  <v-list-item-title>Edit Booking</v-list-item-title>
                </v-list-item>
                <!-- Not required for Kirri. Stallholders are creating & paying for their own bookings --> <!--
                <v-list-item v-if="item.is_paid!==1 && (item.type=='regular')" @click="openNotifyConfirmation(item)">
                    <v-list-item-title>Send Email Notification</v-list-item-title>
                </v-list-item>
                -->
                <v-list-item v-if="item.stallholder_id" :to="`/stallholders/${item.stallholder_id}`">
                    <v-list-item-title>View Stallholder</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="filterBy != 'deleted'" @click="openDeleteConfirmation(item.booking_id)">
                  <v-list-item-title>Delete Booking</v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-for="(item, i) in actions"
                  :key="i"
                  @click="false"
                >
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item>
              </v-list>
              <v-list v-else>
                <v-list-item
                  @click="openBookStallDialog(item.stall_id)"
                >
                  <v-list-item-title>Book stall {{item.name}}</v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="item.is_unavailable"
                  @click="updateStallUnavailability(item.stall_id, false, selectedMarketDate)"
                >
                  <v-list-item-title>Make stall available this week</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="item.stallholder_id" @click="openBookDefaultConfirmation(item, item.type=='regular')">
                    <v-list-item-title>Book In{{ item.type=='regular' ? ' & Notify' : ''}} default Stallholder</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="item.stallholder_id" :to="`/stallholders/${item.stallholder_id}`">
                    <v-list-item-title>View default Stallholder</v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="!item.is_unavailable"
                  @click="updateStallUnavailability(item.stall_id, true, selectedMarketDate)"
                >
                  <v-list-item-title>Make {{item.name}} unavailable this week</v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="!item.is_unavailable"
                  @click="openStallCategoriesDialog(item.stall_id)"
                >
                  <v-list-item-title>Block Categories in {{item.name}} this week</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>

          <!-- Stallholder Type -->
          <template v-slot:item.type="{ item }">
            <stallholder-type-icon v-if="(isBooked(item) || filter.isDefaults) && item.type" :type="item.type"></stallholder-type-icon>
          </template>

          <template v-slot:item.stallholder="{ item }">
            <mailto-btn v-if="item.email" :email="item.email"></mailto-btn>

            <button text @click="$router.push('/stallholders/'+item.stallholder_id)" v-if="(item.booking_id && item.stallholder && item.stallholder_id) || (filter.isDefaults && item.stallholder && item.stallholder_id)">{{ item.stallholder }}</button>
            <span v-else-if="(item.booking_id && item.stallholder) || (filter.isDefaults && item.stallholder)">{{ item.stallholder }}</span>

            <v-chip v-else-if="item.booking_id && item.stallholder && item.is_cancelled">{{ item.stallholder }}</v-chip>
            <v-chip v-else-if="item.is_unavailable">{{ item.stallholder }}</v-chip>
            <button text @click="$router.push('/stallholders/'+item.stallholder_id)" v-else-if="item.stallholder" class="grey--text font-italic">Default: {{ item.stallholder }}</button>

            <v-tooltip v-if="item.stallholder_admin_note" bottom>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" v-if="item.stallholder_id" :to="`/stallholders/${item.stallholder_id}`" class="mx-2" fab dark x-small depressed color="error">
                  <v-icon dark>mdi-account-alert</v-icon>
                </v-btn>
              </template>
              <span>{{item.stallholder_admin_note}}</span>
            </v-tooltip>

          </template>

          <!-- Paid status -->
          <template v-slot:item.is_paid="{ item }">
            <paid-status :item="item"></paid-status>
          </template>

          <!-- Cancelled Status -->
          <template v-slot:item.is_cancelled="{ item }">
            <cancelled-status :item="item"></cancelled-status>
          </template>

          <template v-slot:item.status_info="{ item }">
            <v-tooltip v-for="(icon, i) in item.status_icons" :key="i" bottom>
              <template v-slot:activator="{ on }">
                <v-icon @click="handleFunctionCall(icon.action, icon.params)" v-on="on" :color="icon.color? icon.color : '' " class="mx-1">{{icon.icon}}</v-icon>
              </template>
              <span>{{icon.tooltip}}</span>
            </v-tooltip>
          </template>

          <!-- Deleted Date -->
          <template v-slot:item.deleted_date="{ item }">
            {{ formatDate(item.deleted_date) }}
          </template>

          <template v-slot:top>

          </template>
        </v-data-table>
      </v-card>

      <v-footer
        padless
        dark
        class="transparent"
        fixed
        v-show="isToTopFabVisible"
      >
        <v-col
          class="text-center"
          cols="12"
              
        >

       <v-chip
      class="px-6"
      color="primary"
      label
      large
    >
      <v-icon left>mdi-calendar</v-icon>
     {{ this.mysqlDateToString(this.date) }}
    </v-chip>
        </v-col>
      </v-footer>

      <v-btn
        v-scroll="onScroll"
        v-show="isToTopFabVisible"
        fab
        dark
        fixed
        bottom
        right
        color="primary"
        @click="goToTop"
        >
        <v-icon large>mdi-chevron-up</v-icon>
      </v-btn>

      <BookingModal
        :dialogVisible="isDialogVisible"
        :selectedItem="selectedBooking ? selectedBooking : {stall_id: selectedStallId, market_date: date}"
        @close="dialogClose"
        @save="dialogSave"
        @create="createBooking"
        @update="updateBooking"
        :key="selectedBooking ? selectedBooking.id : selectedStallId"
      />

      <StallModal
        :dialogVisible="isStallDialogVisible"
        :selectedId="selectedStallId"
        @close="closeStallDialog"
        @createBooking="createBooking($event)"
      />

      <StallCategoriesDialog
        :dialogVisible="isStallCategoriesDialogVisible"
        :selectedId="selectedStallId"
        @close="closeStallCategoriesDialog"
      />

      <ConfirmationDialog
        :dialogVisible="confirmationDialog.show"
        :text="confirmationDialog.text"
        :heading="confirmationDialog.heading"
        @cancel="closeConfirmationDialog"
        @confirm="handleFunctionCall(confirmationDialog.action, confirmationDialog.params)"
      />


      <BookingReminderDialog
        :dialogVisible="isBookingReminderDialogVisible"
        :selectedId="selectedStallholderId"
        @close="isBookingReminderDialogVisible=false"
        @update="updateBooking"
      />

      <v-dialog
        v-model="alertDialog.show"
        max-width="500px"
      >
        <v-card>
          <v-card-title>
            <span>{{alertDialog.heading}}</span>
            <div class="flex-grow-1"></div>
          </v-card-title>
          <v-card-text v-html="alertDialog.text">
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="primary"
              text
              @click="alertDialog.show = false"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-overlay :value="isSaving" z-index="1000">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

    </v-container>
</template>

<script>

import axios from 'axios';
import BookingModal from '../components/BookingModal';
import StallModal from '../components/StallModal';
import StallCategoriesDialog from '../components/StallCategoriesDialog';
import BookingReminderDialog from '../components/BookingReminderDialog';
import ConfirmationDialog from '../components/ConfirmationDialog';
import { mapGetters } from 'vuex'
import bookingsTableMixin from '../js/bookingsTableMixin';
import datePickerMixin from '../js/datePickerMixin';
import excelDownload from '../js/excelDownloadMixin'
import PaidStatus from '../components/PaidStatus';
import CancelledStatus from '../components/CancelledStatus';
import StallholderTypeIcon from '../components/StallholderTypeIcon';
import MailtoBtn from '../components/MailtoBtn';
import { formatDate } from '../js/helpers'


export default {
  props: {
    marketDate: {
      required: false,
    }
  },
  data() {
    return {
      search: '',
      date: '',
      datemenu: false,
      isDialogVisible: false,
      numberOfBookedStalls: null,
      headers: [
        {
          text: 'Stall',
          align: 'left',
          value: 'name',
        },
        { text: 'Type', value: 'type',  width: '80px'},
        { text: 'Stallholder Business Name', value: 'stallholder' },
        { text: 'Stallholder Category', value: 'stallholder_category' },
        { text: 'Phone', value: 'stallholder_phone' },
        { text: 'Cancelled', value: 'is_cancelled', sortable: true, align: 'center', width: '120px'},
        { text: 'Paid', value: 'is_paid',  sortable: true, align: 'center', width: '120px' },
        { text: 'Deleted Date', value: 'deleted_date', sortable: true, align: 'right'},
        { text: '', value: 'status_info', sortable: false, align: 'right'},
        { text: '', value: 'actions', sortable: false, align: 'right',  width: '50px'}
      ],
       actions: [
        // { title: 'Booking Details' },
        // { title: 'Stall Details???' }
      ],
      data : [],
      bookingData: [],
      isLoading: false,
      isStallDialogVisible: false,
      isStallCategoriesDialogVisible: false,
      selectedStallId: false,
      selectedBookingId: false,
      selectedStallholderId: false,
      filter: {
        // isDeleted: 0,
        isDefaults: 0,
        // isEmpty: 0,
        // isExpired: 0,
      },
      confirmationDialog: {
        show: false,
        heading: 'Delete Booking',
        text: '',
        action: '',
        params: ''
      },
      alertDialog: {
        show: false,
        heading: '',
        text: ''
      },
      isSaving: false,
      optionsLoading: false,
      marketOptions: {
        ignore_rules: false
      },
      isToTopFabVisible: false,
      isBookingReminderDialogVisible: false,
      filterOptions: [
        {
          'text': 'Bookings',
          'value': 'bookings',
        },
        {
          'text': 'Empty Stalls',
          'value': 'empty',
        },
        {
          'text': 'Deleted Bookings',
          'value': 'deleted',
        },
        {
          'text': 'Expired Bookings',
          'value': 'expired',
        },
      ],
      filterBy: 'bookings'
    }
  },
  watch: {
    date(newData, oldData){
      console.log("wtaching date", newData)
      this.$store.dispatch('updateDate', newData)
      //this.$store.dispatch('fetchStallData', { });
    },
    marketDate(newData, oldData){ // if route changes by pressing back/forward in browser or by changing the url manually from a previous date
      console.log(`watching MARKET DATE ROUTE param : prev ${oldData}, new: ${newData}`)

      if(this.date !== newData){
        console.log('NOT THE SAME get new data')
        this.date = newData
        this.getBookings();
      }
    }
  },
  mixins: [ bookingsTableMixin, datePickerMixin, excelDownload ],
  components: {
    BookingModal,
    StallModal,
    ConfirmationDialog,
    StallCategoriesDialog,
    BookingReminderDialog,
    PaidStatus,
    CancelledStatus,
    StallholderTypeIcon,
    MailtoBtn
  },
  methods: {
    isBooked(stall) {
      return stall.booking_id ? true : false
    },
    getMarketResults(){

      this.isLoading = true;

      let self=this;
      console.log("GETTING MARKET RESULTS")
      //axios.get('http://glebe.local/wp-json/wp/v2/booking?status=paid', {
      axios.get(`/wisdom-markets/v1/market/${this.date}`, {

            // params: {
            // status: 'pending'
            // },
            headers: {
              //'Authentication': `Bearer ${this.$store.state.accessToken}`,
               'Authorization': `Bearer ${this.$store.state.accessToken}`,
             },
        })
        .then(function (response) {
            console.log(response);
            //this.data = response.data;

            // self.pagesTotal = parseInt(response.headers['x-wp-totalpages'])
            console.warn(response.headers['x-wp-totalpages'])

            let data = response.data;

            data.forEach(item => {
                item["stall_id"] = item.id;
                //item["name"] = item.title;
                //item["type"] =false
                //item['paid'] = false;
              if(item.booking ){
                //item["type"] = 'monthly'; //todo
                //item["stallholder"] = parseInt(item.booking.stallholder_id); // either 1 date or 2 dates separated by : (for a date range)
                if(item.booking.post_status == 'paid'){
                  //item['paid'] = true;
                  //item["type"] = 'permanent'; //todo
                }

                  console.log(item.booking.post_status)
              }else{
               item["stallholder"] = false;
              }
            });

            // if (isNewSearch)
               self.data = data; // replace all old posts with new results
            // else
            //  self.data.push(...data); // we are 'loading more': append new results

            // if(newPosts.length == 0)
            //   this.loadMessage = "No data found"; // for when there is actually no data
            // else
            //   this.loadMessage = ""

            // _this.pagesTotal = response.headers["x-wp-totalpages"];
            self.isLoading = false

        })
        .catch(function (error) {
            console.log(error);
            console.log("why t hefick!!!");
        })
        .then(function () {
            // always executed
        });  

        this.getBookings();
    },
    loadBookingsDate(){
        this.$router.push({ name: "market", params: { date: this.date } });
        this.getBookings();
    },
    getBookings(){

      this.getMarketOptions();

      let self=this;

      this.isLoading = true;

      axios.get(`/wisdom-markets/v1/bookings/${this.date}`, {
          headers: {
            'Authorization': `Bearer ${this.$store.state.accessToken}`,
          },
        })
        .then(function (response) {
            console.warn('lili', response);

            let data = response.data;
            
            self.bookingData = data; // replace all old posts with new results

            self.numberOfBookedStalls = data.filter(d => d.status == 'paid').length

            self.isLoading = false

        })
        .catch(function (error) {
            console.log(error);
            console.log("why thefick!!!");
        })
        .then(function () {
            // always executed
        });  
    },
     getMarketOptions(){

      this.optionsLoading = true;

      axios.get(`/wisdom-markets/v1/markets/${this.date}`, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.accessToken}`,
        },
      })
      .then( response => {
          this.marketOptions = response.data; // replace all old posts with new results
          this.optionsLoading = false
      })
      .catch(function (error) {
        console.log(error);
      })
    },
    updateMarketOptions(option, value) {
      this.optionsLoading = true;
      axios({
        method: 'POST',
        url: `/wisdom-markets/v1/markets/${this.date}`,
        headers: {
          'Authorization': `Bearer ${this.$store.state.accessToken}`,
        }, 
        data: this.marketOptions
      })
      .then(response => {
        console.log("updated market options", response);
        this.optionsLoading = false;
        this.marketOptions = response.data // reassign results incase any issues
      })
      .catch( (error, res) => {
        this.optionsLoading = false;
        this.marketOptions[option] = !value; //revert if error
        console.log("ERROR");
        this.alertDialog.heading = "Error!"
        this.alertDialog.text = `Cannot update market option ${option}: ${error.message}`
        this.alertDialog.show = true;
      });
    },
    incrementDate(weeks){
      let date = new Date(this.date);
      let now = new Date();   
      //now.setTime("1568073240062"); // for testing timezones
      //console.warn({now});

      let offset = -(now.getTimezoneOffset()/60);  
      let newTimestamp = date.setDate(date.getDate() + 7 * weeks);

      this.date = new Date(newTimestamp + offset * 3600 * 1000).toISOString().substr(0, 10);

      //this.getMarketResults();
      this.getBookings();

    },
    openBookStallDialog (id) { 
      this.isDialogVisible = true
      this.selectedStallId = id;
    },
    openEditBookingDialog (id) { 
      this.isDialogVisible = true
      this.selectedBookingId = id;
    },
    openStallCategoriesDialog (id) {
      this.isStallCategoriesDialogVisible = true
      this.selectedStallId = id
    },
    closeStallCategoriesDialog (id) {
      this.isStallCategoriesDialogVisible = false
      this.selectedStallId = false
    },
    dialogClose () { 
      this.isDialogVisible = false;

      // wait half a sec, before resetting data (otherwise we see the stall name cleared in the booking dialog before the dialog fully transitions)
      setTimeout(() => {
       this.selectedStallId = false;
       this.selectedBookingId = false;
      }, 500)  
    },
    dialogSave () { 
      console.log("SAVVVVV todo new");
      this.isDialogVisible = false;
    },
    openStallDialog (id) {
      this.isStallDialogVisible = true
      this.selectedStallId = id
    },
    closeStallDialog (id) {
      this.isStallDialogVisible = false
      this.selectedStallId = false
    },
    createBooking(payload){
      let newBookings = [];
      
      if(Array.isArray(payload))
        newBookings = payload;
      else
        newBookings.push(payload);

      newBookings.forEach(newBooking => {
        if(newBooking.market_date == this.date) {
          // current viewed market date is the same as the booking just created
          this.bookingData.push(newBooking);
          console.warn("PUSHING to bookings", newBooking)
        }
        //else we don't need to save the booking data if on a different date, because when that date is viewed fresh data is fetched from server
      })
    },
    updateBooking(payload){
      console.group("update booking in market results");

      let index = this.bookingData.findIndex(item => item.id===payload.id);

      if (index !== -1)  {

        if(payload.market_date == this.date) { console.warn("MARKET DATE DID NOT CHANGE - so we are updating current viewed list")
            this.bookingData.splice(index, 1, payload); 
        }else{  console.warn("MARKET DATE CHANGED - so deleting from current viwed list")
            // then remove from current market list 
            this.bookingData.splice(index, 1);        
        }

      }else{
        console.log("couldn't find index") // should not happen
      }
      console.groupEnd()
    },

    openDeleteConfirmation(id) {
      this.selectedBookingId = id;
      this.confirmationDialog.text = `Are you sure you want to delete the booking for <strong>${this.selectedBooking.stallholder_stall_name}</strong> in stall <strong>${this.getStallName(this.selectedBooking.stall_id)}</strong> on <strong>${this.mysqlDateToString(this.selectedBooking.market_date)}</strong>?`
      this.confirmationDialog.show = true
      this.confirmationDialog.action = 'deleteBooking'
      this.confirmationDialog.params = [id]
    },
    closeConfirmationDialog (payload) {
      this.confirmationDialog.show = false
    },
    openBookDefaultConfirmation(item, notify = false){
      this.selectedStallId = item.stall_id;
      this.confirmationDialog.heading= notify ? "Book & Notify?" : "Create Booking?"
      this.confirmationDialog.text = `Are you sure you want to book${ notify ? ' & notify' : ''} <strong>${item.stallholder}</strong> in stall <strong>${item.name}</strong> on <strong>${this.mysqlDateToString(this.date)}</strong>?`
      this.confirmationDialog.show = true
      this.confirmationDialog.action = 'bookDefault'
      this.confirmationDialog.params = [item, notify]
    },
    openNotifyConfirmation(item) {
    //   this.selectedBookingId = item.booking_id;
    //   this.confirmationDialog.heading="Notify stallholder?"
    //   this.confirmationDialog.text = `Are you sure you want to send an email reminder to <strong>${item.stallholder}</strong> of their booking in <strong>${this.getStallName(item.stall_id)}</strong>?`
    //   this.confirmationDialog.show = true
    //   this.confirmationDialog.action = 'sendBookingNotification'
    //   this.confirmationDialog.params = [item.booking_id]
      
      this.selectedStallholderId = item.stallholder_id;
      this.isBookingReminderDialogVisible = true;

    },
    deleteBooking(id) {
      console.log("need to delete here booking id = "+this.selectedStallId);
      console.warn(this.selectedBooking);
      this.isSaving = true;
      axios({
        method: 'DELETE',
        url: `/wisdom-markets/v1/bookings/${this.selectedBooking.id}`,
        headers: {
          'Authorization': `Bearer ${this.$store.state.accessToken}`,
        }, 
        //data: { is_deleted: 1 }
      })
      .then(response => {
          console.log("deleted", response);
          this.isSaving = false;
          this.confirmationDialog.show = false
          this.selectedBookingId = false;
          this.updateBooking(response.data);
      })
      .catch( (error, res) => {
          this.isSaving = false;
          this.alertDialog.heading = "Error!"
          this.alertDialog.text = `Cannot delete booking: ${error.message}`
          this.alertDialog.show = true;
          // self.savingDialog = false;
      });
    },
    sendBookingNotification(id) {
      console.log("need to notify stallholder of booking id = "+this.selectedBookingId);
      console.warn(this.selectedBooking);
      this.isSaving = true;
      axios({
        method: 'POST',
        url: `/wisdom-markets/v1/bookings/${id}`,
        headers: {
          'Authorization': `Bearer ${this.$store.state.accessToken}`,
        }, 
        data: { notify: 1 }
      })
      .then(response => {
        console.log("notified", response);
        this.isSaving = false;
        this.confirmationDialog.show = false
        this.selectedBookingId = false;
        this.updateBooking(response.data);
      })
      .catch( (error, res) => {
        this.isSaving = false;
        this.alertDialog.heading = "Error!"
        this.alertDialog.text = `Cannot notify stallholder: ${error.message}`
        this.alertDialog.show = true;
        this.selectedBookingId = false;
        // self.savingDialog = false;
      });
    },
    bookDefault(item, notify = false){
      this.isSaving = true;

      let data = {};

      data.stallholder_id = item.stallholder_id
      data.stall_id = item.stall_id
      data.market_date=this.date;

      if(notify)
        data.notify=1;
      
      axios({
        method: 'POST',
        url: `/wisdom-markets/v1/bookings/`,
        headers: {
            'Authorization': `Bearer ${this.$store.state.accessToken}`,
        }, 
        data: data
      })
      .then(response => {
        console.log("saved", response);
        this.isSaving = false;
        this.createBooking(response.data)
        this.closeConfirmationDialog();
      })
      .catch((error) => {
        console.log("error saving", error);
        this.isSaving = false;
        this.alertDialog.heading = "Error!"
        this.alertDialog.text = `Cannot create booking: ${error.message}`
        this.alertDialog.show = true;
      });
    },
    updateStallUnavailability(stall_id, value, date){
      this.isSaving = true;

      let data = {
        market_data: {}
      };

      data.market_data[date] = { 'is_unavailable': value };

      axios({
        method: 'POST',
        url: `/wisdom-markets/v1/stalls/${stall_id}`,
        headers: {
          'Authorization': `Bearer ${this.$store.state.accessToken}`,
        }, 
        data: data
      })
      .then(response => {
        console.log("saved", response);
        this.isSaving = false;
        this.$store.commit('updateStall', response.data);
      })
      .catch((error) => {
        console.log("error saving", error);
        this.isSaving = false;
      });
    },
    mysqlDateToString: function (value) {
      let date = new Date(value);
      return date.toLocaleDateString( "en-US", { year: 'numeric', month: 'long', day: 'numeric' } );
    },
    handleFunctionCall(action, params) {
      this[action](...params)
    },
    formatDate(date){
      return formatDate(date);
    },
    onScroll (e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset || e.target.scrollTop || 0
      this.isToTopFabVisible = top > 20
    },
    goToTop () {
      this.$vuetify.goTo(0)
    },
    nowDateTime() {
      let now = new Date();   
    
      //now.setTime("1568073240062"); // for testing

      let offset = -(now.getTimezoneOffset()/60);  

      //let thisSaturdayTimestamp = now.setDate(now.getDate() + (this.marketDay +(7-now.getDay())) % 7);

      //this.date = new Date(thisSaturdayTimestamp + offset * 3600 * 1000).toISOString().substr(0, 10);

                  var d = new Date();
// console.log(new Date(now + offset * 3600 * 1000).toISOstring()); //'2013-10-01T00:00:00.000Z'
 console.log(new Date(now + offset * 3600 * 1000).toISOString()); //'Fr

 console.log(new Date(now + offset * 3600 * 1000).toString()); //'Fr
console.error("whataa");

let date = new Date(now + offset * 3600 * 1000);

return date.getFullYear() + '-' +
    ('00' + (date.getMonth()+1)).slice(-2) + '-' +
    ('00' + date.getDate()).slice(-2) + ' ' + 
    ('00' + date.getHours()).slice(-2) + ':' + 
    ('00' + date.getMinutes()).slice(-2) + ':' + 
    ('00' + date.getSeconds()).slice(-2);


    //   return  new Date(now + offset * 3600 * 1000).toISOString().substr(0, 19).replace('T', ' ');
    }
  },
  computed: {
    dateFormatted() { // for read only date picker text field
      if (!this.date) return null;

      const [year, month, day] = this.date.split('-')
      return `${parseInt(day, 10)}/${month}/${year}`
    },
    selectedMarketDate() {
      return this.$store.state.selectedMarketDate;
    },
     ...mapGetters([
      'getStallholderById',
      'getStallholderName',
      'getDefaultStallholderIdForStall',
      'getCategoryById',
      'getStallName', // this is only used incase the stall name gets updated we want the bookings/market list to be auto updated
      'getStallById'
    ]),
    tableData(){
      if(this.filter.isDefaults) {
        return this.$store.state.stalls.map( item => {

          let newItem = {};

          newItem.name = item.stall_title
          newItem.stall_id = item.id;
          newItem.stall_admin_note = item.admin_note;   

          let stallholder = false;

          if(item.stallholder)
            stallholder = this.getStallholderById(item.stallholder);
            

          if(stallholder){
            newItem.stallholder_id = item.stallholder;
            newItem.type=stallholder.stallholder_type
            newItem.stallholder = `${stallholder.stall_name} (${stallholder.first_name} ${stallholder.last_name})`;
            newItem.stallholder_admin_note = stallholder.admin_note;   

            let category = this.getCategoryById(stallholder.category);
            if(category)
              newItem.stallholder_category = category.name;
          }

          return newItem;
        });
      }
      else if(this.filterBy =='deleted' || this.filterBy == 'expired' ) {
        return this.bookingData.map( item => {
          
          let stall = this.getStallById(item.stall_id);
          if(stall) { // a stall should always exists, check during dev to not produce js errors
            item.name = stall.stall_title;
            item.stall_admin_note = stall.admin_note; 
          }

          item.stallholder = `${item.stallholder_stall_name} (${item.first_name} ${item.last_name})`;

          item.booking_id = item.id;

          let stallholder = this.getStallholderById(item.stallholder_id);

          if(stallholder) {
            item.type=stallholder.stallholder_type
            item.stallholder_admin_note = stallholder.admin_note;  

            let category = this.getCategoryById(stallholder.category);
            if(category)
              item.stallholder_category = category.name;

          } 
            // else{
            //     item.stallholder = "UNKNOWN!"
            // }

          item.status_icons = [];

          if(item.expiry_date){
            item.status_icons.push({
              icon: 'mdi-timer',
              action: 'openEditBookingDialog',
              params: [item.booking_id],
              tooltip: 'Expired: '+formatDate(item.expiry_date),
              color: 'red'
            });
          }

          if(item.admin_note){
            item.status_icons.push({
              icon: 'mdi-note-text-outline',
              action: 'openEditBookingDialog',
              params: [item.booking_id],
              tooltip: 'Booking Admin Note',
              color: 'red lighten-2'
            });
          }

           return item;
        }).filter( item => {

          if(this.filterBy =='deleted')
            return item.deleted_date ? true : false
          else if(this.filterBy =='expired')
            return item.expiry_date && item.expiry_date < this.nowDateTime() && !item.deleted_date ? true : false

        }).sort( (a, b) => { 
          if(this.filterBy == 'deleted')
            return a.deleted_date === b.deleted_date ? 0 :  a.deleted_date >  b.deleted_date ? -1 : 1; // default order is by deleted date
          else if(this.filterBy =='expired')   
            return a.expiry_date === b.expiry_date ? 0 :  a.expiry_date >  b.expiry_date ? -1 : 1; // default order is by deleted date

        });
      }

    

      //return this.data.map( item => {
      return this.$store.state.stalls.map( item => {

        //console.warn(item.id)
        let newItem = {};

        //newItem.stall_id = item.stall_id;
        newItem.stall_id = item.id;

        //newItem.name = this.getStallName(item.id); console.log(`looking for ${item.id}`)
        newItem.name = item.stall_title
        newItem.stall_admin_note = item.admin_note;   

        newItem.status_icons = []

        if(item.market_date_data && item.market_date_data.blocked_categories && item.market_date_data.blocked_categories.length > 0){
          newItem.status_icons.push({
            icon: 'mdi-close-box-multiple-outline',
            action: 'openStallCategoriesDialog',
            params: [newItem.stall_id],
            tooltip: 'Blocked Categories'
          });
        }
        //console.log("STALL "+newItem.name);

        let booking = this.bookingData.filter( booking => item.id == booking.stall_id && booking.deleted_date == null && (!booking.expiry_date || booking.expiry_date > this.nowDateTime() ) )
        if(booking.length>0) {
          booking = booking[0];
         // console.log("ther is an undeleted abooking "+booking.id);
        }else{
          booking = false
         // console.log("ther is NOT A   abooking");
        }

        if(booking && booking.deleted_date == null && this.filterBy != 'deleted') {

          console.log("lililili");console.log(booking);
          newItem.is_paid = booking.is_paid;
          newItem.stallholder = `${booking.stallholder_stall_name} (${booking.first_name} ${booking.last_name})`;
          newItem.stallholder_id = booking.stallholder_id;
          newItem.is_cancelled = booking.is_cancelled;
          newItem.booking_id = booking.id;
          newItem.type= booking.stallholder_type;
          newItem.stallholder_admin_note = booking.stallholder_admin_note;
          newItem.first_name = booking.first_name;   
          newItem.stallholder_phone = booking.phone;
          newItem.payment_id = booking.payment_id;  
          newItem.email = booking.email; 
          
        //   if(booking.stallholder_id) {
        //     let stallholder = booking.stallholder_id ? this.getStallholderById(booking.stallholder_id) : false;

        //     if(stallholder) {
        //       newItem.type=stallholder.stallholder_type;
        //       newItem.stallholder_admin_note = stallholder.admin_note;   
        //     }
        //   }

        //   if(!booking.email) { // we have OLD bookings data pre: guest booking functionality implemented (client had live data in the system) so we need this or we somehow populate database 
        //     console.warn("old booking data structure "+booking.id);
        //     let stallholder = booking.stallholder_id ? this.getStallholderById(booking.stallholder_id) : false;

        //     if(stallholder) {
        //       newItem.type=stallholder.stallholder_type;
        //       newItem.stallholder_admin_note = stallholder.admin_note;   
        //       newItem.stallholder_phone = stallholder.phone;   

        //       console.info(`type of stallholder ${booking.stallholder_id} is ${newItem.type}`)

        //       let category = this.getCategoryById(stallholder.category);
        //       if(category)
        //         newItem.stallholder_category = category.name;
        //     }

        //   }else{
            let category = this.getCategoryById(booking.category);
            if(category)
              newItem.stallholder_category = category.name;

        //   }

        //   if(!newItem.stallholder)
        //             newItem.stallholder = "UNKNOWN"
            //temporary or expiry bookings with have a stallholder of 0
            //console.error(`cannot find type of stallholder ${booking.stallholder_id} for booking id ${booking.id}` )

          if(booking.expiry_date){ console.error("expiry"+booking.expiry_date);
            newItem.status_icons.push({
              icon: 'mdi-timer',
              action: 'openEditBookingDialog',
              params: [newItem.booking_id],
              tooltip: 'Expires '+booking.expiry_date,
              color: 'red'
            });
          }

          if(booking.admin_note){
            newItem.status_icons.push({
              icon: 'mdi-note-text-outline',
              action: 'openEditBookingDialog',
              params: [newItem.booking_id],
              tooltip: 'Booking Admin Note',
              color: 'red lighten-2'
            });
          }

          /* Not required for Kirri. Stallholders are creating & paying for their own bookings */ /*
          if(!booking.last_emailed_date) {
            newItem.status_icons.push({
              icon: 'mdi-email-alert',
              action: '',
              params: [],
              tooltip: 'Stallholder has not been notified yet',
              color: 'orange lighten-2'
            });
          }
          */

        

        }else{
          //console.log("???"+ booking.deleted_date)
          newItem.type="";
          newItem.is_paid = -1
          newItem.stallholder = null;
          newItem.is_cancelled = -1;
          newItem.booking_id = null;
          
 
          if(item.market_date_data && item.market_date_data.is_unavailable){
            newItem.is_unavailable = true;
            newItem.stallholder = "Unavailable this market date";
          }else if(item.is_unavailable && (!item.market_date_data || !(typeof item.market_date_data.is_unavailable !== 'undefined' &&  !item.market_date_data.is_unavailable) )){
            newItem.is_unavailable = true;
            newItem.stallholder = "Unavailable indefinitely";
          }else{
            let defaultStallholderId = item.stallholder;

            if(defaultStallholderId) { console.log("TODO get default stallholder because getStallholderById will now be empty");
              let defaultStallholder = this.getStallholderById(defaultStallholderId);
              if(defaultStallholder) {
                newItem.stallholder = defaultStallholder.stall_name
                //newItem.type=defaultStallholder.stallholder_type // we NEED this if we want the book "& notify" (but not really needed now that we have the email reminders when client chooses which dates to remind)
                newItem.stallholder_id = defaultStallholderId;
              }
            }
          }
        }

        return newItem;

      }).filter( item => {

        if(this.filterBy == 'deleted') return item.deleted_date
          
        if(this.filterBy == 'empty') return !item.booking_id
            
        return true 

      })


    },
    selectedBooking() {
       let booking = this.bookingData.find( booking => this.selectedBookingId == booking.id)

      // let booking = this.bookingData.find( booking => this.selectedStallId == booking.stall_id)

      // // if no booking found or its a 'deleted' booking AND we are not currently looking at deleted booking
      // if(!booking || (booking.deleted_date != null && !this.filter.isDeleted)) return false
      
      return booking
    },
    tableHeaders() {

      return this.headers.filter(item => {

        // if(item.value=='stallholder_category' && !this.filter.isDefaults)
        //   return false

        if(item.value=='stallholder_phone' && (this.filter.isDefaults || this.filterBy=='deleted'))
          return false

        if(item.value=='deleted_date' && (this.filter.isDefaults || this.filterBy != 'deleted'))
          return false

        if(this.filter.isDefaults && (item.value=='is_cancelled' || item.value=='is_paid' || item.value=='actions' ) )
          return false

        return true
      })
    }
  },
  mounted(){

    /* Set default date for datepicker, ie this saturday */
    if(this.marketDate) {
      this.date = this.marketDate;
    } else if(this.selectedMarketDate) {
      this.date = this.selectedMarketDate;
    }else{
      let now = new Date();   
    
      //now.setTime("1568073240062"); // for testing

      let offset = -(now.getTimezoneOffset()/60);  

      let thisSaturdayTimestamp = now.setDate(now.getDate() + (this.marketDay +(7-now.getDay())) % 7);

      this.date = new Date(thisSaturdayTimestamp + offset * 3600 * 1000).toISOString().substr(0, 10);
    }

    this.$store.commit('updatePickerAvailableMarketsDates', {dates: [this.date]}); // so we dont have to wait for picker to fetch all dates in year

    this.$store.commit('setDate', this.date)

    console.log(this.date);

    //this.getMarketResults();
    this.getBookings();

    // this.$store.dispatch('getStallholders', { });

    //this.$store.dispatch('fetchStallData', { });

    this.$store.dispatch('getStallholderCategories', { });
  }
}
</script>

<style lang="scss">
.v-card.theme--dark,
.theme--dark.v-data-table { background-color: #3b4158 !important; }
.theme--dark.v-data-table tbody tr:hover:not(.v-data-table__expand-row) {
    background: rgba(255, 255, 255, 0.1);
}
</style>